<template>
    <div class="clientsBox">
        <el-tabs v-model="activeNameBig" @tab-click="handleClickBig">
            <el-tab-pane label="客户" name="first">
                <!-- ------------------------------------------------------ -->
                <header>
                    <el-form class="headerForm bodyForm" :model="searchLS">
                        <el-row type="flex">
                            <el-form-item>
                                <el-input
                                    clearable
                                    size="medium"
                                    placeholder="姓名 / 手机号"
                                    v-model="searchLS.key"
                                    class="input-with-select"
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select
                                    size="medium"
                                    v-model="searchLS.intention_level"
                                    placeholder="请选择意向等级"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in intentionLevel"
                                        :key="item.value"
                                        :label="item.key"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-select
                                    size="medium"
                                    v-model="searchLS.track_status"
                                    placeholder="请选择客户阶段"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in track_status"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- </el-col> -->
                            <el-form-item>
                                <el-select
                                    size="medium"
                                    v-model="searchLS.staff_id"
                                    placeholder="请选择经纪人"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in market"
                                        :key="item.uid"
                                        :label="item.username"
                                        :value="item.uid"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="!searchLS.staff_id">
                                <el-select
                                    size="medium"
                                    v-model="searchLS.status"
                                    placeholder="请选择领取状态"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in $const.statusLS"
                                        :key="item.value"
                                        :label="item.key"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <div style="transform: translateY(5px)">
                                <el-button
                                    type="primary"
                                    @click="getImgList(true)"
                                    size="small"
                                    >搜索</el-button
                                >
                            </div>
                        </el-row>
                    </el-form>
                </header>

                <el-table
                    :data="rightRequestData"
                    row-key="id"
                    ref="tableRef"
                    @select="select"
                    @select-all="select_all"
                    border
                    stripe
                    v-loading="isLoading"
                >
                    <el-table-column
                        v-if="tableType"
                        width="55"
                        type="selection"
                        align="center"
                        :reserve-selection="true"
                        :selectable="selectable"
                    ></el-table-column>
                    <el-table-column
                        prop="id"
                        label
                        v-if="false"
                    ></el-table-column>
                    <el-table-column
                        prop="clue_id"
                        label
                        v-if="false"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="relaname"
                        label="姓名"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        label="手机号"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="intention_level"
                        label="意向等级"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="update_time"
                        label="近期更新时间"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="track_status_title"
                        label="客户阶段"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="staff_name"
                        label="当前销售"
                    ></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <div slot-scope="scope" class="operation">
                            <div
                                class="view"
                                @click="advertiseUpdate(scope.row.id)"
                            >
                                详情
                            </div>
                        </div>
                    </el-table-column>
                </el-table>
                <div class="ruleBt">
                    <el-button
                        :type="butType"
                        size="small"
                        @click="textHandler"
                        >{{ textBt }}</el-button
                    >
                    <el-button
                        v-if="
                            (kejianShow && is_leader == 1
                              ? true
                              : false)
                                ? false
                                : tableType
                        "
                        type="primary"
                        size="small"
                        @click="textHandler1"
                        >{{ textBt2 }}</el-button
                    >
                    <el-button
                        v-if="kejianShow && is_leader == 1 ? true : false"
                        type="primary"
                        size="small"
                        @click="textHandler1"
                        >{{ textBt2 }}</el-button
                    >
                </div>
                <!-- 分页 -->
                <div class="tablePage">
                    <el-pagination
                        hide-on-single-page
                        background
                        @size-change="sizePage"
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        :page-sizes="[15, 20, 25]"
                        layout="total, sizes, prev, pager, next"
                    ></el-pagination>
                </div>
                <!-- --------------------------------------------------------- -->
            </el-tab-pane>
            <el-tab-pane
                label="企业客户"
                name="second"
                v-if="is_corp == 1 ? false : true"
            >
                <!-- ---------------------------------------------------------------------- -->
                <header>
                    <el-form class="headerForm bodyForm" :model="searchLS">
                        <el-row type="flex">
                            <el-form-item>
                                <el-input
                                    clearable
                                    size="medium"
                                    placeholder="姓名"
                                    v-model="searchLS.key"
                                    class="input-with-select"
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select
                                    size="medium"
                                    v-model="searchLS.intention_level"
                                    placeholder="请选择意向等级"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in intentionLevel"
                                        :key="item.value"
                                        :label="item.key"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-select
                                    size="medium"
                                    v-model="searchLS.track_status"
                                    placeholder="请选择客户阶段"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in track_status"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- </el-col> -->
                            <el-form-item>
                                <el-select
                                    size="medium"
                                    v-model="searchLS.staff_id"
                                    placeholder="请选择经纪人"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in market"
                                        :key="item.uid"
                                        :label="item.username"
                                        :value="item.uid"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <div style="transform: translateY(5px)">
                                <el-button
                                    type="primary"
                                    @click="getData"
                                    size="small"
                                    >搜索</el-button
                                >
                            </div>
                            <div
                                style="transform: translateY(5px)"
                                class="fixed"
                                @click="synchronization"
                            >
                                <el-button type="primary" size="small"
                                    >同步客户</el-button
                                >
                            </div>
                        </el-row>
                    </el-form>
                </header>

                <el-table
                    :data="twoRequestData"
                    row-key="id"
                    border
                    stripe
                    v-loading="isLoading"
                >
                    <el-table-column
                        type="index"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="id"
                        label
                        v-if="false"
                    ></el-table-column>
                    <el-table-column
                        prop="clue_id"
                        label
                        v-if="false"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="relaname"
                        label="姓名"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="intention_level"
                        label="意向等级"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="update_time"
                        label="近期更新时间"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="track_status_title"
                        label="客户阶段"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="staff_name"
                        label="当前销售"
                    ></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <div slot-scope="scope" class="operation">
                            <div
                                class="view"
                                @click="advertiseUpdate(scope.row.id)"
                            >
                                详情
                            </div>
                        </div>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="tablePage">
                    <el-pagination
                        hide-on-single-page
                        background
                        @size-change="sizePage"
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        :page-sizes="[15, 20, 25]"
                        layout="total, sizes, prev, pager, next"
                    ></el-pagination>
                </div>
                <!-- --------------------------------------------------------------------------- -->
            </el-tab-pane>
        </el-tabs>

        <el-drawer
            title="客户详情"
            :visible.sync="rightDialog"
            direction="rtl"
            size="1100px"
            class="drawer"
        >
            <el-tabs v-model="activeName" class="mlt" @tab-click="handleClick">
                <el-tab-pane label="基础信息" name="one">
                    <el-descriptions
                        class="margin-top"
                        title="基本信息"
                        :column="3"
                        border
                    >
                        <el-descriptions-item>
                            <template slot="label">用户名</template>
                            {{ information.relaname }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">性别</template>
                            {{ information.sex }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">电话</template>
                            {{ information.phone }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">意向等级</template>
                            {{ information.intention_level }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">房产状态</template>
                            {{ information.property }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">贷款状态</template>
                            {{ information.loan }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">当前跟进员工</template>
                            {{ information.staff_name }}
                        </el-descriptions-item>
                    </el-descriptions>
                    <h4
                        style="
          margin:20px 0"
                    >
                        客户来源
                    </h4>
                    <el-table
                        :data="information.origin"
                        border
                        stripe
                        v-loading="isLoading"
                    >
                        <el-table-column
                            prop="source"
                            label="来源项目"
                        ></el-table-column>
                        <el-table-column
                            prop="channel"
                            label="来源渠道"
                        ></el-table-column>
                        <el-table-column
                            prop="create_time"
                            label="来源时间"
                        ></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="客户标签" name="two">
                    <ClientLabel :id="parent_id" :index="index"></ClientLabel>
                </el-tab-pane>
                <el-tab-pane label="客户动态" name="three">
                    <ClientDynamic
                        :id="parent_id"
                        :index="index"
                    ></ClientDynamic>
                </el-tab-pane>
                <el-tab-pane label="订单" name="fore">
                    <Order :id="parent_id" :index="index"></Order>
                </el-tab-pane>
                <el-tab-pane label="领取记录" name="five">
                    <ReceiveRecord
                        :id="parent_id"
                        :index="index"
                    ></ReceiveRecord>
                </el-tab-pane>
            </el-tabs>
        </el-drawer>
        <el-dialog
            :title="title"
            custom-class="listDialog"
            width="500px"
            style="padding-bottom:30px"
            :visible.sync="bottomDialog"
            @close="close"
        >
            <Dialog
                :staff="market"
                @checkRadio="checkRadio"
                ref="DialogRef"
            ></Dialog>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="ruleSubmit()"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            title="可见"
            custom-class="listDialog"
            width="500px"
            style="padding-bottom:30px"
            :visible.sync="bottomDialog1"
            @close="
                () => {
                    textBt = '转接'
                    textBt2 = '可见'
                    tableType = false
                    $refs.selectStaffRef.init()
                }
            "
        >
            <selectStaff
                @staffCollBack="staff_id = $event"
                ref="selectStaffRef"
            >
            </selectStaff>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="ruleSubmit1()"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import selectStaff from '@/components/selectStaff'
import Dialog from '@/components/clients/dialog.vue'
import ClientLabel from '@/components/clients/cletnyLabel.vue'
import Order from '@/components/clients/order.vue'
import ReceiveRecord from '@/components/clients/receiveRecord.vue'
import ClientDynamic from '@/components/clients/clientDynamic.vue'

export default {
    components: {
        Dialog,
        ClientLabel,
        ReceiveRecord,
        ClientDynamic,
        Order,
        selectStaff,
    },
    data() {
        return {
            butType: 'primary',
            textBt: '转接',
            textBt2: '可见',
            staff_id: [],
            tableType: false, //表格复选框
            is_corp: '',
            is_leader: '',
            flag: 0,
            indexBig: 0,
            checkList: [],
            bottomDialog: false,
            bottomDialog1: false,
            activeNameBig: 'first',
            market: [],
            track_status: [],
            title: '转接客户',
            intentionLevel: [],
            searchLS: {},
            activeName: 'one',
            isLoading: false,
            rightRequestData: [],
            rightDialog: false,
            search: {
                total: 0,
                page: 1,
                limit: 15,
            },
            information: {}, //基础信息
            parent_id: '',
            index: '',
            val: '',
            twoRequestData: [],
            kejianShow: true,
        }
    },

    async mounted() {
        let dynamicConfig = await this.$store.dispatch('dynamicConfig')
        this.intentionLevel = this.$store.state.app.globalConfig.intentionLevel
        this.track_status = dynamicConfig.phase
        this.market = dynamicConfig.staff
        this.getImgList()
        this.is_corp = this.$store.state.app.myStoreCur.is_corp
        this.is_leader = this.$store.state.app.myStoreCur.is_leader
    },
    watch: {
        textBt(val) {
            if (val === '取消转接' || val === '取消可见') {
                this.butType = 'info'
                return
            }
            this.butType = 'primary'
        },
        'search.page'() {
            this.indexBig == 1 ? this.getData() : this.getImgList()
        },
        'search.limit'() {
            this.indexBig == 1 ? this.getData() : this.getImgList()
        },
        rightDialog() {
            this.activeName = 'one'
            this.index = 0
        },
        indexBig(val) {
            this.search.total = 0
            this.search.page = 1
            this.search.limit = 15
            this.searchLS = {}
            if (val == 1) {
                this.getData()
            } else {
                this.getImgList()
            }
        },
    },
    methods: {
        textHandler() {
            if (this.textBt == '取消转接' || this.textBt == '取消可见') {
                this.$refs.tableRef.clearSelection()
                this.checkList = []
                this.tableType = false
                this.textBt = '转接'
                this.textBt2 = '可见'
                return
            }
            this.tableType = true
            this.textBt = '取消转接'
            this.textBt2 = '确认转接'
        },
        textHandler1() {
            if (this.textBt2 == '确认可见') {
                if (this.checkList.length) this.bottomDialog1 = true
                else this.$commonFun.toast('请选择客户', 'warning')
                return
            }
            if (this.textBt2 == '确认转接') {
                if (this.checkList.length) this.bottomDialog = true
                else this.$commonFun.toast('请选择客户', 'warning')
                return
            }
            this.tableType = true
            this.textBt = '取消可见'
            this.textBt2 = '确认可见'
        },
        selectable(row) {
            if (this.textBt2 == '确认可见') {
                if (row.staff_name) return false
                return true
            } else {
                return true
            }
        },
        async synchronization() {
            this.isLoading = true
            await this.$api.synchroCustomer()
            this.getData()
            this.$commonFun.toast('同步成功', 'success')
        },
        async getData() {
            this.isLoading = true
            let param = {
                ...this.search,
                ...this.searchLS,
            }
            const date = await this.$api.workCustomer(param)
            this.search.total = date.count
            this.twoRequestData = date.data
            this.isLoading = false
        },
        handleClickBig(val) {
            this.indexBig = val.index
        },
        // selection_change(val) {
        //     if (val.length == this.rightRequestData.length) {
        //         this.$nextTick(() => {
        //             this.flag = 1
        //         })
        //     }
        //     if (val.length == 0 || val.length < this.rightRequestData.length) {
        //         this.$nextTick(() => {
        //             this.flag = 0
        //         })
        //     }
        // },
        select_all(val) {
            this.checkList = val.map((v) => v.id)
            // if (this.flag) {
            //     this.checkList = []
            //     this.flag = 0
            //     return
            // }
            // this.flag++
            // let checkAll = val.map((res) => res.id)
            // if (!this.checkList.length) {
            //     this.checkList.push(...checkAll)
            //     return
            // }
            // checkAll.forEach((row) => {
            //     let index = this.checkList.findIndex(
            //         (element) => element == row
            //     )
            //     if (index == -1) this.checkList.push(row)
            // })
        },
        select(val, item) {
            this.checkList = val.map((v) => v.id)
            // if (this.checkList.indexOf(item.id) == -1) {
            //     this.checkList.push(item.id)
            // } else {
            //     let index = this.checkList.findIndex((res) => res == item.id)
            //     this.checkList.splice(index, 1)
            // }
        },
        sizePage(val) {
            this.search.limit = val
        },
        // 组件关闭
        close() {
            this.textBt = '转接'
            this.textBt2 = '可见'
            this.tableType = false
            this.$refs.DialogRef.init()
        },
        checkRadio(val) {
            this.val = val
        },
        ruleSubmit1() {
            this.ruleSubmit(true)
        },
        async ruleSubmit(isrefash) {
            if (isrefash) {
                if (!this.staff_id.length)
                    return this.$commonFun.toast('请选择经纪人', 'warning')

                let params = { staff: this.staff_id, ids: this.checkList }
                const res = await this.$api.clientVisible(params)
                this.bottomDialog1 = false
            } else {
                if (!this.val)
                    return this.$commonFun.toast('请选择经纪人', 'warning')
                this.bottomDialog = false
                let params = { staff_id: this.val, customer_id: this.checkList }
                const res = await this.$api.transfer(params)
            }

            this.$commonFun.toast('SUCCESS', 'success')
            if (!this.indexBig) this.$refs.tableRef.clearSelection()
            this.checkList = []
            this.flag = 0
            this.getImgList()
        },
        handleClick(val) {
            this.index = val.index
        },
        async advertiseUpdate(id) {
            this.parent_id = id
            this.rightDialog = true
            let param = { id }
            const date = await this.$api.customerInfo(param)
            this.information = date
        },
        async getImgList(refash) {
            if (refash) {
                this.search.page = 1
                if (Object.keys(this.searchLS).length) {
                    this.$refs.tableRef.clearSelection()
                }
            }
            this.kejianShow = true
            if (this.searchLS.status == 1) this.kejianShow = false
            this.isLoading = true
            let param = {
                ...this.search,
                ...this.searchLS,
            }
            const date = await this.$api.customerList(param)
            this.search.total = date.count
            this.rightRequestData = date.data
            this.isLoading = false
        },
    },
}
</script>

<style lang="scss">
.clientsBox {
    position: relative;
    .verbal {
        .topEnd {
            font-size: 15px;
            margin-bottom: 10px;
            color: #999;
        }
        .operation {
            display: flex;
            align-items: center;
        }
    }
    .mlt {
        margin: 0 20px 20px;
    }
}
</style>
